<div class="video-player-container">
    <div class="play-button">
        <i class="fa fa-youtube-play"></i>
    </div>
</div>